/* global dataLayer */

export default {
  handle(event, obj) {
    if (typeof dataLayer === 'undefined') {
      return;
    }

    dataLayer.push({
      event,
      ...obj,
    });
  },

  event(category, action, label, value = 0) {
    this.handle('ga_event', {
      ga_event_category: category,
      ga_event_action: action,
      ga_event_label: label,
      ga_event_value: value,
    });
  },

  timing(category, value) {
    this.handle('timing', {
      timing_name: category,
      timing_value: value,
    });
  },

  vitals(event, obj) {
    this.handle(event, obj);
  },
};
